/**
 * Navigation Data Structure
 * Comprehensive menu configuration for Finease legal services website
 * Structure: Top-level → Categories → Sub-Categories → Services
 */

export const navigationData = [
  {
    id: "home",
    label: "Home",
    path: "/",
  },
  {
    id: "services",
    label: "Services",
    path: "/services",
    categories: [
      {
        id: "registrations",
        label: "Registrations",
        subcategories: [
          {
            id: "business-registrations",
            label: "Business",
            services: [
              {
                id: "msme-registration",
                label: "MSME Registration",
                path: "/services/msme-registration",
                description: "Register your micro, small or medium enterprise",
              },
              {
                id: "startup-india",
                label: "Startup India Registration",
                path: "/services/startup-india",
                description: "Get DPIIT recognition and benefits",
              },
              {
                id: "shop-establishment",
                label: "Shop & Establishment",
                path: "/services/shop-establishment",
                description: "State-level shop license registration",
              },
              {
                id: "trade-license",
                label: "Trade License",
                path: "/services/trade-license",
                description: "Municipal trade license for business",
              },
            ],
          },
          {
            id: "ngo-registrations",
            label: "NGO",
            services: [
              {
                id: "trust-registration",
                label: "Trust Registration",
                path: "/services/trust-registration",
                description: "Register a charitable or private trust",
              },
              {
                id: "society-registration",
                label: "Society Registration",
                path: "/services/society-registration",
                description: "Register under Societies Registration Act",
              },
              {
                id: "section-8-company",
                label: "Section 8 Company",
                path: "/services/section-8-company",
                description: "Non-profit company registration",
              },
            ],
          },
        ],
      },
      {
        id: "incorporations",
        label: "Incorporations",
        subcategories: [
          {
            id: "companies",
            label: "Companies",
            services: [
              {
                id: "private-limited",
                label: "Private Limited Company",
                path: "/services/private-limited-company",
                description: "Most popular business structure in India",
              },
              {
                id: "public-limited",
                label: "Public Limited Company",
                path: "/services/public-limited-company",
                description: "For large-scale public enterprises",
              },
              {
                id: "one-person-company",
                label: "One Person Company (OPC)",
                path: "/services/one-person-company",
                description: "Single owner company with limited liability",
              },
              {
                id: "llp-registration",
                label: "LLP Registration",
                path: "/services/llp-registration",
                description: "Limited Liability Partnership formation",
              },
              {
                id: "partnership-firm",
                label: "Partnership Firm",
                path: "/services/partnership-firm",
                description: "Traditional partnership registration",
              },
              {
                id: "proprietorship",
                label: "Sole Proprietorship",
                path: "/services/sole-proprietorship",
                description: "Single-owner business registration",
              },
            ],
          },
          {
            id: "conversions",
            label: "Conversions",
            services: [
              {
                id: "opc-to-pvt-ltd",
                label: "OPC to Pvt Ltd",
                path: "/services/opc-to-private-limited",
                description: "Convert OPC to Private Limited Company",
              },
              {
                id: "llp-to-pvt-ltd",
                label: "LLP to Pvt Ltd",
                path: "/services/llp-to-private-limited",
                description: "Convert LLP to Private Limited Company",
              },
              {
                id: "pvt-to-public",
                label: "Pvt Ltd to Public",
                path: "/services/private-to-public-limited",
                description: "Convert Private to Public Limited",
              },
            ],
          },
        ],
      },
      {
        id: "compliance",
        label: "Compliance",
        subcategories: [
          {
            id: "annual-compliance",
            label: "Annual",
            services: [
              {
                id: "annual-filing",
                label: "Annual Filing",
                path: "/services/annual-filing",
                description: "Yearly compliance filings for companies",
              },
              {
                id: "roc-filing",
                label: "ROC Filing",
                path: "/services/roc-filing",
                description: "Registrar of Companies filings",
              },
              {
                id: "director-kyc",
                label: "Director KYC",
                path: "/services/director-kyc",
                description: "Annual director verification (DIR-3 KYC)",
              },
            ],
          },
          {
            id: "changes",
            label: "Changes",
            services: [
              {
                id: "company-name-change",
                label: "Name Change",
                path: "/services/company-name-change",
                description: "Change your company's registered name",
              },
              {
                id: "registered-address-change",
                label: "Address Change",
                path: "/services/registered-address-change",
                description: "Change registered office address",
              },
              {
                id: "authorized-capital-increase",
                label: "Capital Increase",
                path: "/services/authorized-capital-increase",
                description: "Increase authorized share capital",
              },
              {
                id: "share-transfer",
                label: "Share Transfer",
                path: "/services/share-transfer",
                description: "Transfer shares between shareholders",
              },
            ],
          },
          {
            id: "closure",
            label: "Closure",
            services: [
              {
                id: "company-strike-off",
                label: "Strike Off",
                path: "/services/company-strike-off",
                description: "Remove dormant company from register",
              },
              {
                id: "company-winding-up",
                label: "Winding Up",
                path: "/services/company-winding-up",
                description: "Formal company closure process",
              },
              {
                id: "llp-closure",
                label: "LLP Closure",
                path: "/services/llp-closure",
                description: "Close your LLP legally",
              },
            ],
          },
        ],
      },
      {
        id: "tax-gst",
        label: "Tax & GST",
        subcategories: [
          {
            id: "gst-services",
            label: "GST",
            services: [
              {
                id: "gst-registration",
                label: "GST Registration",
                path: "/services/gst-registration",
                description: "Register for Goods and Services Tax",
              },
              {
                id: "gst-return-filing",
                label: "GST Returns",
                path: "/services/gst-return-filing",
                description: "Monthly/quarterly GST return filing",
              },
              {
                id: "gst-lut-filing",
                label: "LUT Filing",
                path: "/services/gst-lut-filing",
                description: "Letter of Undertaking for exporters",
              },
              {
                id: "e-way-bill",
                label: "E-Way Bill",
                path: "/services/e-way-bill",
                description: "Generate e-way bills for transport",
              },
              {
                id: "gst-annual-return",
                label: "GST Annual Return",
                path: "/services/gst-annual-return",
                description: "GSTR-9 annual return filing",
              },
            ],
          },
          {
            id: "tax-services",
            label: "Tax",
            services: [
              {
                id: "income-tax-filing",
                label: "ITR Filing",
                path: "/services/income-tax-filing",
                description: "Individual and business tax returns",
              },
              {
                id: "tds-filing",
                label: "TDS Filing",
                path: "/services/tds-filing",
                description: "Tax Deducted at Source compliance",
              },
              {
                id: "tax-planning",
                label: "Tax Planning",
                path: "/services/tax-planning",
                description: "Strategic tax optimization services",
              },
            ],
          },
        ],
      },
      {
        id: "licenses",
        label: "Licenses",
        subcategories: [
          {
            id: "business-licenses",
            label: "Business Licenses",
            services: [
              {
                id: "fssai-license",
                label: "FSSAI License",
                path: "/services/fssai-license",
                description: "Food safety license for food businesses",
              },
              {
                id: "iec-code",
                label: "IEC Code",
                path: "/services/iec-code",
                description: "Import Export Code registration",
              },
              {
                id: "bis-certification",
                label: "BIS Certification",
                path: "/services/bis-certification",
                description: "Bureau of Indian Standards certification",
              },
              {
                id: "iso-certification",
                label: "ISO Certification",
                path: "/services/iso-certification",
                description: "International quality management standards",
              },
              {
                id: "drug-license",
                label: "Drug License",
                path: "/services/drug-license",
                description: "License for pharmaceutical business",
              },
            ],
          },
        ],
      },
      {
        id: "intellectual-property",
        label: "Intellectual Property",
        subcategories: [
          {
            id: "trademark",
            label: "Trademark",
            services: [
              {
                id: "trademark-registration",
                label: "Trademark Registration",
                path: "/services/trademark-registration",
                description: "Protect your brand identity",
              },
              {
                id: "trademark-search",
                label: "Trademark Search",
                path: "/services/trademark-search",
                description: "Check trademark availability",
              },
              {
                id: "trademark-objection",
                label: "Trademark Objection",
                path: "/services/trademark-objection",
                description: "Respond to examiner objections",
              },
              {
                id: "trademark-opposition",
                label: "Trademark Opposition",
                path: "/services/trademark-opposition",
                description: "Oppose or defend trademark applications",
              },
              {
                id: "trademark-renewal",
                label: "Trademark Renewal",
                path: "/services/trademark-renewal",
                description: "Renew your trademark registration",
              },
            ],
          },
          {
            id: "other-ip",
            label: "Copyright & Patent",
            services: [
              {
                id: "copyright-registration",
                label: "Copyright Registration",
                path: "/services/copyright-registration",
                description: "Protect creative and literary works",
              },
              {
                id: "patent-registration",
                label: "Patent Registration",
                path: "/services/patent-registration",
                description: "Protect your inventions",
              },
            ],
          },
        ],
      },
      {
        id: "legal-documents",
        label: "Legal Documents",
        subcategories: [
          {
            id: "documents",
            label: "Documents",
            services: [
              {
                id: "legal-notice",
                label: "Legal Notice",
                path: "/services/legal-notice",
                description: "Draft and send legal notices",
              },
              {
                id: "agreements-drafting",
                label: "Agreements",
                path: "/services/agreements-drafting",
                description: "Custom agreement drafting",
              },
              {
                id: "affidavit-drafting",
                label: "Affidavits",
                path: "/services/affidavit-drafting",
                description: "Sworn statement preparation",
              },
              {
                id: "contract-drafting",
                label: "Contracts",
                path: "/services/contract-drafting",
                description: "Business contract drafting",
              },
              {
                id: "nda-agreement",
                label: "NDA",
                path: "/services/nda-agreement",
                description: "Non-disclosure agreement drafting",
              },
              {
                id: "power-of-attorney",
                label: "Power of Attorney",
                path: "/services/power-of-attorney",
                description: "POA drafting and registration",
              },
            ],
          },
        ],
      },
      {
        id: "disputes",
        label: "Disputes",
        subcategories: [
          {
            id: "dispute-resolution",
            label: "Resolution",
            services: [
              {
                id: "consumer-complaint",
                label: "Consumer Complaint",
                path: "/services/consumer-complaint",
                description: "File consumer forum complaints",
              },
              {
                id: "legal-notice-dispute",
                label: "Legal Notice",
                path: "/services/legal-notice-dispute",
                description: "Send legal notices for disputes",
              },
              {
                id: "arbitration",
                label: "Arbitration",
                path: "/services/arbitration",
                description: "Alternative dispute resolution",
              },
            ],
          },
        ],
      },
      {
        id: "cxo-services",
        label: "CXO Services",
        subcategories: [
          {
            id: "executive-services",
            label: "Executive Services",
            services: [
              {
                id: "virtual-cfo",
                label: "Virtual CFO",
                path: "/services/virtual-cfo",
                description: "On-demand financial leadership",
              },
              {
                id: "payroll-compliance",
                label: "Payroll Compliance",
                path: "/services/payroll-compliance",
                description: "Complete payroll management",
              },
              {
                id: "compliance-manager",
                label: "Compliance Manager",
                path: "/services/compliance-manager",
                description: "End-to-end compliance management",
              },
            ],
          },
        ],
      },
    ],
  },
  {
    id: "team",
    label: "Team",
    path: "/team",
  },
  {
    id: "blog",
    label: "Blog",
    path: "/blog",
  },
];

// Helper function to get all services as flat array
export const getAllServices = () => {
  const services = [];
  navigationData.forEach((menu) => {
    menu.categories?.forEach((category) => {
      category.services?.forEach((service) => {
        services.push({
          ...service,
          menuId: menu.id,
          menuLabel: menu.label,
          categoryId: category.id,
          categoryLabel: category.label,
        });
      });
    });
  });
  return services;
};

// Helper function to find a service by path
export const getServiceByPath = (path) => {
  return getAllServices().find((service) => service.path === path);
};

// Helper function to get related services
export const getRelatedServices = (serviceId, limit = 4) => {
  const allServices = getAllServices();
  const currentService = allServices.find((s) => s.id === serviceId);
  if (!currentService) return [];

  // Get services from same category first, then same menu
  const sameCategory = allServices.filter(
    (s) => s.categoryId === currentService.categoryId && s.id !== serviceId
  );
  const sameMenu = allServices.filter(
    (s) =>
      s.menuId === currentService.menuId &&
      s.categoryId !== currentService.categoryId &&
      s.id !== serviceId
  );

  return [...sameCategory, ...sameMenu].slice(0, limit);
};

// Popular services for quick access
export const popularServices = [
  "private-limited",
  "gst-registration",
  "trademark-registration",
  "income-tax-filing",
  "llp-registration",
  "fssai-license",
];

export default navigationData;
